import {Component, OnDestroy, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PortfolioService} from './portfolio.service';
import {PortfoliosGridLayoutService} from './portfolios.grid-layout.service';
import {
    IMultiplePortfolioEditRequest,
    IPortfolioExportRequest,
    IPortfolioFilterDDList,
    IPortfolioModel,
    IPortMissingAccountAndModel,
    IRebalResponseObject,
    Portfolio,
    PortfolioCount
} from '@irb/irb-clients/irb-clients.model';
import {HttpHeaders} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {
  IEvent,
  IEventSubscriber,
  IrbAppEvents,
  IrbClientsEvents,
  IrbCreatePortfolioEvents, IrbDialogsEvents,IrbEditorsEvents,
  IrbRebalanceEvents,
  IrbSettingsEvents
} from '@irb-common/events';
import {ReplaySubject, Subscription, interval} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DataTransferService} from '@irb/irb-common/services/data-transfer.service';
import {SelectAllGridParent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import {IrbAgGridExportService} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import {MenuItemDef} from 'ag-grid-enterprise';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {EasternTimePipe} from '@irb-common/pipes/EasternTimePipe';
import {IPortfolioCustomLabel} from '@irb/irb-editors/irb-editors.model';
import {IAlertDialogData, IApplyFilterOnLanding, IFilterModel} from '@irb/app.model';
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {FilterChipsComponent} from "@irb-common/components/filter-chips/filter-chips.component";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import { IrbClientsService } from '../irb-clients.service';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {IGlobalSettings} from "@irb/irb-settings/irb-settings.model";
import {SettingsPortfoliosComponent} from "@irb/irb-settings/settings-portfolios/settings-portfolios.component";
import { PortfolioLabelsService } from './portfolios.labels.service';
import {IrbGridBaseClass} from "@irb-common/components/grid/irb-grid.base";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {PreferencesService} from "@irb-common/services/preferences.service";

@Component({ standalone: false,
  selector: 'dux-portfolios',
  styleUrls: ['./portfolios.component.scss'],
  templateUrl: './portfolios.component.html',
  providers: [CurrencyPipe, DatePipe, EasternTimePipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PortfoliosComponent extends IrbGridBaseClass implements OnInit, OnDestroy, IEventSubscriber, SelectAllGridParent {
  params: any;
  public rowData: any[];
  public info: string;
  gridOptions: any;
  defaultColDef: any;
  columnDefs: any;
  rowSelection: any;
  rowModelType: any;
  portfolioCount: PortfolioCount;
  totalRecordsFromServer: number;
  currentPortfoliosDisplayed: number;
  portfolioContentRange: any;
  portfolioModelList: IPortfolioFilterDDList;
  portfolioRestrictionList: IPortfolioFilterDDList;
  modelNames: string[] = [];
  restrictionNames: string[] = [];
  portfolioCreatedUserList: string[] = [];
  portfolioEditedUserList: string[] = [];
  statusValues: string[] = [];
  sideBar: any;
  disableActionBtn = true;
  disableFinmasonBtn = true;
  selectedTaxability: string[] = [];
  selectedPriorityNote: string;
  pendingResults: string;
  taxlossResults: string;
  frameworkComponents: any;
  filterMissingModel: any;
  filterMissingAccount: any;
  icons: any;
  footerContent: any;
  loadingOverlayComponentParams: any;
  overlayType: any;
  uniqueField = 'portfolioId';
  eventSubscription: Subscription;
  successfulImportCount: number;
  displaySuccessfulImport: boolean;
  acountsinit: boolean;
  restrictionsInit: boolean;
  _filterCriteria: string;
  selectedAccountValues: string[] = [];
  customCategory: string;
  missingCountDetails: IPortMissingAccountAndModel;
  headerCheckBoxState: string;
  securityModelId: number = 0;
  filterAccounts: any = [];
  applyFilterOnLanding: IApplyFilterOnLanding;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  isLoading: boolean;
  queryParams: any = null;
  routeQueryParams$: Subscription;
  private showClearFilters: boolean = false;
  _filterChipModel: any = {};
  @ViewChild("filterChipsComp")
  filterChipsComp: FilterChipsComponent;
  filterDisplayNamesData: { key: string, mapData: { displayName: string, customData: any, format?: any } }[];
  firstTimeFlag = true;
  isUiTest = false;
  hilitedPortfolios: Number[] = [];
  private showFirstPortfolioEdit = false;
  hasServerSideDatasource = false;
  globalSettings: IGlobalSettings;
  isAutoRebalanceEnabled: boolean;
  globalSettingsReceived: boolean;
  gainsControlSettingOptions: Array<string>;
  updatePortfolioNamesSub: Subscription;
  updateImportModelAndCategorySub: Subscription;
  selectedOrDeSelectedRecords: any[] = [];
  selectedRowsMap = new Map<string, any>();
  @ViewChild('noOptionsTemplate') noOptionsTemplate: TemplateRef<any>;
  redirectURL: string;
  window: any;
  componentName = 'portfolioComponent-v003';
  baseGridApi: any;
  private ENABLE_PORT_ACC_APIS: boolean = false;
  columnLimits: any;
  ENABLE_GAINS_THRESHOLD: boolean = false;
  gridFilterPreference = 'portfolios-filter-pref';
  ENABLE_CUSTOM_HOMEPAGE: boolean = false;
  masterAccountList: string[] = [];
  gridColumnPreference = 'portfolios-column-pref';

  constructor(
    private readonly pfs: PortfolioService,
    private cs: IrbClientsService,
    public dialog: MatDialog,
    public as: AppService,
    private readonly router: Router,
    public dts: DataTransferService,
    public ges: IrbAgGridExportService,
    private gls: PortfoliosGridLayoutService,
    private route: ActivatedRoute,
    public ats: AnalyticsService,
    public iss: IrbSettingsService,
    private util: UtilityService,
    public pls: PortfolioLabelsService,
    public ies: IrbEditorsService,
    public pref: PreferencesService
  ) {
    super();
      this.ats.trackPortfolioEvent();
      this.valuesCallbackList();
      this.routeQueryParams$ = route.queryParams.subscribe((params: any) => {
          if (params['lastResults'] && params['portfolio']) {
            this.showLastResults({rebalId: params['lastResults'], portfolioId: params['portfolio']});
          }
        }
      );
      this.setFilterChipsDisplayNames();
      const user_details: any = this.as.getItem('IRB_APP_CONFIG');
      this.redirectURL = user_details?.veoRedirectUrl;
      this.window = window;
      this.presetFiltersdataFromSavedFilters();
      this.ENABLE_PORT_ACC_APIS = user_details?.featureFlags.ENABLE_PORT_ACC_APIS || false;
      this.ENABLE_GAINS_THRESHOLD = user_details?.featureFlags.ENABLE_GAINS_THRESHOLD || false;
      this.columnLimits = this.gls.getColumnLimits();
      this.ENABLE_CUSTOM_HOMEPAGE = user_details?.featureFlags?.ENABLE_CUSTOM_HOMEPAGE || false;
      this.getGridColumnPreference();
  }

  _portfolios: any[];

  get portfolios() {
    return this._portfolios;
  }

  set portfolios(portfolios: any) {
    this._portfolios = portfolios;
  }

  _isSelectedAll: boolean;

  get isSelectedAll() {
    return this._isSelectedAll;
  }

  set isSelectedAll(isSelectedAll: boolean) {
    this._isSelectedAll = isSelectedAll;
  }

  _deselectedFromSelectAllRecords: any[] = [];

  get deselectedFromSelectAllRecords() {
    return this._deselectedFromSelectAllRecords;
  }

  set deselectedFromSelectAllRecords(deselectedFromSelectAllRecords: any[]) {
    this._deselectedFromSelectAllRecords = deselectedFromSelectAllRecords;
  }

  ngOnInit() {
    const self = this;
    if (SettingsPortfoliosComponent.gainsControlSettingOptions.length < 3) {
      this.iss.getGainsControlsDropDown().subscribe((dropDownData: string[]) => {
        SettingsPortfoliosComponent.gainsControlSettingOptions = [];
        dropDownData.forEach(dropDownItem => {
          SettingsPortfoliosComponent.gainsControlSettingOptions.push({
            name: dropDownItem,
            value: dropDownItem
          });
        });
        this.populateGainsControlSettingOptions();
      });
    } else {
      this.populateGainsControlSettingOptions();
    }
    this.applyFilterOnLanding = this.as.getWindowsState();

    let rowIdIteration = -1;
    this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
      self.globalSettings = globalSettings;
      self.globalSettingsReceived = true;
      this.customCategory = globalSettings.portfolioCustLabelAbbr || 'CustCat';
      this.setFilterChipsDisplayNames();
      self.isAutoRebalanceEnabled = self.globalSettings?.isAutoRebalanceEnabled;

      let columnDefs = this.gls.getColumnDefs(this);
      if (this.ENABLE_CUSTOM_HOMEPAGE) {
        columnDefs.push({
          headerName: 'Master Account',
          field: 'masterAccount',
          hide: true,
          suppressColumnsToolPanel: true,
          filter: 'agSetColumnFilter',
          filterParams: {
            buttons: ['reset', 'apply'],
            suppressMiniFilter: true,
            values: (params: any) => {
              params.success(this.masterAccountList);
            },
            newRowsAction: 'keep',
            suppressSorting: true,
            cellHeight: 30,
            closeOnApply: true
          }
        });
      }

      this.gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: columnDefs,
        rowSelection: 'multiple',
        onSortChanged: () => {
          if(this.hasServerSideDatasource) {
            this.setDatasource();
          // } else {
          //   if (this.applyFilterOnLanding && !this.applyFilterOnLanding.isUpdatRequired)
          //     this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }
        },
        context: {componentParent: this},
        getRowId: (params: any) => {
          rowIdIteration++;
          const rowId = 'RowId' + rowIdIteration;
          return params.data.portfolioId + rowId;
        },
        rowClassRules: {
          'modifiedRow': (function (params: any) {
            return (params.data) ? this.hilitedPortfolios.indexOf(params.data.portfolioId) !== -1 : false;
          }).bind(this)
        }
      };

      self.rowModelType = 'serverSide';
      self.getPortfolioCount();
      self.frameworkComponents = self.gls.getFrameworkComponents();

      self.sideBar = {
        toolPanels: [{
          id: 'filters',
          labelDefault: 'FILTERS',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          toolPanelParams: {
            suppressExpandAll: true,
            suppressFilterSearch: true,
            suppressSyncLayoutWithGrid: true,
          }
        }]
      };

      self.filterMissingModel = false;
      self.filterMissingAccount = false;
      self.loadingOverlayComponentParams = {parentObject: this};
      self.selectedTaxability = ['DEFERRED', 'ROTH', 'TAXABLE'];
      self.selectedPriorityNote = self.as.extractFromSession("PORTFOLIO_NOTE_FILTER_DEFAULT") || 'ALL';
      self.pendingResults = self.as.extractFromSession("PORTFOLIO_PENDING_RESULTS_FILTER_DEFAULT") || "ALL";
      self.taxlossResults = self.as.extractFromSession("PORTFOLIO_TAXLOSS_RESULTS_FILTER_DEFAULT") || "ALL";
      self.eventSubscription = self.as.getEvents().pipe(takeUntil(self.destroyed$)).subscribe((s: any) => {
        self.processEvent(s);
      });
      self.displaySuccessfulImport = false;
    });
  }
  populateGainsControlSettingOptions() {
    this.gainsControlSettingOptions = SettingsPortfoliosComponent.gainsControlSettingOptions.map((f: any) => {
      return f.name
    });
  }
  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbAppEvents.GRID_REFRESH:
        this.refreshGrid();
        break;
      case IrbAppEvents.GRID_FILTER_RESET:
        this.clearAllFiltersAndSelections();
        break;
      case IrbSettingsEvents.SHOW_PORTFOLIOS_BY_CATEGORY:
        this.applyFilterOnLanding = event?.data;
        this.setPortfolioCategoryFilterEvent();
        break;
      case IrbSettingsEvents.PORTFOLIO_CATEGORY_UPDATED:
        if (event.data) {
          if (event.data.type === 'portfolioCategory' && event.data.fromComp === 'PortfoliosComponent') {
            this.resetCategorySearch(event.data)
          }
        }
        break;
      case IrbAppEvents.FIRE_TRACKING_EVENT:
        this.ats.trackPortfolioEvent();
        break;
      case IrbClientsEvents.IMPORT_PORTFOLIO_NAMES_COMPLETE:
        this.completeImportPortfolioNames(event.data);
        break;
      case IrbClientsEvents.IMPORT_MODEL_CATEGORY_COMPLETE:
        this.completeImportModelCategory(event.data);
        break;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();

    if (this.routeQueryParams$) {
      this.routeQueryParams$.unsubscribe();
    }
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  onGridReady(params: any) {
    this.params = params;
    this.baseGridApi = params.api;
    this.customFilterLayout(params);
    this.getPortfolioModel();
    this.getAccountList();
    this.getSecuritySymbols();
    this.pls.getPortfolioLabels(this);
    if (this.ENABLE_CUSTOM_HOMEPAGE)
      this.getMasterNumberList();
    else
      this.getTaxlossResults();
    this.getPortfolioCreatedBy();
    this.getPortfolioEditedBy();
    this.getPendingResults();
    this.getAssignedMMC();

    if(this.hasServerSideDatasource) {
      this.setDatasource();
    } else {
      if (this.applyFilterOnLanding && !this.applyFilterOnLanding.isUpdatRequired) {
        //this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
        this.params.api.showLoadingOverlay();
        this.triggerInitialLoadData(100);
      } else {
        this.masterAccountList = [];
        this.saveGridFiltersToLocal(null);
        let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'portfolioName');
        if (filterModel)
          this.setPortfolioNameFilter();
      }
    }
  }

  setPortfolioNameFilter() {
    if (this.applyFilterOnLanding && this.applyFilterOnLanding.filterModel && this.applyFilterOnLanding.filterModel.name === 'portfolioName') {
      this.params.api?.getColumnFilterInstance('portfolioName').then((f: any) => {
        this.applyFilterOnLanding.isUpdatRequired = false;
        f.values = this.applyFilterOnLanding.filterModel.value;
        this.params.api.setFilterModel({'portfolioName': {
          type: 'startsWith',
          filter: this.applyFilterOnLanding.filterModel.value,
        }});
        this.params.api.onFilterChanged();

        if (!this.hasServerSideDatasource) {
          this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
        }
      });
    }
  }

  setDatasource() {
    this.hasServerSideDatasource = true;
    return {
      getRows: (params: any) => {
        this.overlayType = 'loading';
        this.params.api.showLoadingOverlay();
        params.taxability = this.selectedTaxability;
        params.priorityNote = this.selectedPriorityNote;
        params.pendingResults = this.pendingResults;
        params.taxlossResults = this.taxlossResults;
        params.withoutModel = this.filterMissingModel;
        params.withoutAccount = this.filterMissingAccount;
        params.selectedAccountValues = this.selectedAccountValues;

        const selectedModelIds = this.getSetFilterSelectedGetIds(params, this.portfolioModelList?.items, 'securityModelName');
        const selectedCustCatIds = this.getPortfolioSetFilterSelectedGetIds(params, 'labels');
        const selectedRestrictionIds = this.getSetFilterSelectedGetIds(params, this.portfolioRestrictionList?.items, 'psrQty');
        this.pfs.clearCriteria();
        this._filterChipModel = params.request.filterModel;
        this.setQuickFiltersInChipModel();
        this.pfs.getPortfolios(params, selectedModelIds, selectedCustCatIds, selectedRestrictionIds).subscribe((data: any) => {
          this._filterCriteria = this.pfs._filterCriteria;
          this.portfolios = <Portfolio[]>data.body;
          const ex: any = (this.portfolios as any).responseUtilityMap;
          if (ex) {
            this.params.api.hideOverlay();
            if (ex['Controller Exception'] && !this.isUiTest) {
              if (!this.isUiTest)
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  summary: 'Portfolios Inventory Call Failed.',
                  detail: 'A Controller Exception.'
                });
                return;
            }
          }
          
          this.getCurrentPortfolioCount(data.headers);
          
          if (this.currentPortfoliosDisplayed == 0) {
            this.showClearFilters = this._filterCriteria !== '';
            this.params.api.showNoRowsOverlay();
          } else {
            this.params.api.hideOverlay();
            if (this.showFirstPortfolioEdit) {
              this.showFirstPortfolioEdit = false;
              this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: this.portfolios[0]});
            }
          }
          
          params.success({ rowData: this.portfolios });
          //sa 2024-08-02 this piece of code has constantly been resurrected. Let's keep it commented for some time
          // if (!this.isUiTest) {
          //   this.params.columnApi.setColumnsVisible(['isAutoRebalEnabled'], this.isAutoRebalanceEnabled);
          // }
        }, () => {
            params.success({ rowData: [] });
            this.showClearFilters = this._filterCriteria  !== '';
            this.params.api.hideOverlay();
            this.params.api.showNoRowsOverlay();
            this.saveGridFiltersToLocal(null);
        });
      }
    };
  }

  refreshGrid() {
    this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
      this.globalSettings = globalSettings;

      if(this.customCategory != globalSettings.portfolioCustLabelAbbr) {
        this.customCategory = globalSettings.portfolioCustLabelAbbr || 'CustCat';
        this.setFilterChipsDisplayNames();
        this.params.api.refreshHeader();
      }

      this.hasServerSideDatasource = false;
      //this.params.api.deselectAll();
      //this.headerCheckBoxState = "unchecked";
      // this.selectedOrDeSelectedRecords = [];
      // this.isSelectedAll = false;
      // this.deselectedFromSelectAllRecords = [];
      this.getPortfolioCount();
      this.valuesCallbackList();
      this.modelNames = [];
      this.restrictionNames = [];
      this.getPortfolioModel();
      this.getSecuritySymbols();
      this.pls.portfolioLabels = [];
      this.pls.getPortfolioLabels(this);
      this.getPortfolioCreatedBy();
      this.getPortfolioEditedBy();
      this.getAccountList();
      this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
    });
  }

  applyFilter() {
    this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
  }




  isDisableCheckBox(data: any) {
    if (data) {
      const approvStatus = data.authStatus;
      if (approvStatus === "Unauthorized") {
        return true;
      }
    }
    return false;
  }

  isDisabled(data: any) {
    return this.isDisableCheckBox(data);
  }

  fireRebalanceTypeEvent(params: any) {
    this.ats.trackCreateRebalanceEvent();

    if (params.nextRebalType === "Tax Loss Harvest" || params.nextRebalType === "Harvest tax losses") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_HARVEST_TAX_LOSS_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Fully rebalance securities & cash" || params.nextRebalType === "Full rebalance") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_EDIT_CREATE_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Generate and/or invest cash") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_GENERATE_INVEST_CASH_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Invest cash only") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_INVEST_CASH_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Generate cash only") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_GENERATE_CASH_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Replace securities") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_REPLACE_SECURITIES_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
    if (params.nextRebalType === "Adjust securities") {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_ADJUST_SECURITIES_REBALANCE, {
        fullscreen: true,
        analysisId: params.nextRebalId,
        source: 'Scheduled'
      });
    }
  }

  getPortfolioCount(): void {
    this.pfs.getPortfolioCount().subscribe((portfolioCount: any) => {
      this.portfolioCount = portfolioCount;
      if (this.currentPortfoliosDisplayed) {
        this.footerContent = this.currentPortfoliosDisplayed + ' of ' + this.portfolioCount.pfCount + ' portfolios displayed';
      }
    });
  }

  getAccountList() {
    this.pfs.getAccountsList().subscribe((res: string[]) => {
      this.filterAccounts = this.util.sortArrayList(res);
      let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'acctQty');
      if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
        filterModel.isUpdatRequired = false;
        this.applyFilterOnLanding.isUpdatRequired = false;
        this.params.api.setColumnFilterModel('acctQty', {
          values: filterModel.value // ['11111111']
        });
        if (this.params && this.params.api)
          this.params.api.onFilterChanged();
          //this.params.api.setColumnFilterModel('acctQty').onFilterChanged();

        if (!this.hasServerSideDatasource) {
          setTimeout(() => {
            this.showFirstPortfolioEdit = true;
            if (this.params && this.params.api)
              this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }, 1);
        }
      }
    });
  }

  getPortfolioModel() {
    this.pfs.getPortfolioModel().subscribe((res: IPortfolioFilterDDList) => {
      this.portfolioModelList = res;
      this.modelNames = [];
      for (const record of this.portfolioModelList.items) {
        if (record.name) {
          this.modelNames.push(record.name);
        }
      }

      this.modelNames = this.util.sortArrayList(this.modelNames);
      const recordStatic: IPortfolioModel = {id: 'NoModel', name: '(none)'};
      this.portfolioModelList.items.push(recordStatic);
      this.modelNames.unshift('(none)');
      this.gls.modelNames = this.modelNames;

      this.params.api.getColumnFilterInstance('securityModelName').then((f: any) => {
        let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'securityModelName');
        if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
          filterModel.isUpdatRequired = false;
          this.applyFilterOnLanding.isUpdatRequired = false;

          f.values = this.gls.getDropdownOptions(this.modelNames);
          this.params.api.setFilterModel({'securityModelName': {
            values: filterModel.value,
            defaultToNothingSelected: true
          }});
          this.params.api.onFilterChanged();

          if (!this.hasServerSideDatasource) {
            this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }
        }
      });
    });
  }

  getSecuritySymbols() {
    this.pfs.getSecuritySymbols().subscribe((res: IPortfolioFilterDDList) => {
      this.portfolioRestrictionList = res;
      for (const record of this.portfolioRestrictionList.items) {
        if (record.name) {
          this.restrictionNames.push(record.name);
        }
      }
      this.restrictionNames = this.util.sortArrayList(this.restrictionNames);
      const recordStatic: IPortfolioModel = {id: 'none', name: '(none)'};
      this.portfolioRestrictionList.items.push(recordStatic);
      this.restrictionNames.unshift('(none)');
      let filterModel: any = this.as.getFieldInfo(this.applyFilterOnLanding, 'psrQty');
      if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
        //filterModel.isUpdatRequired = false;
        this.applyFilterOnLanding.isUpdatRequired = false;
        this.params.api.setColumnFilterModel('psrQty', {
          values: filterModel.value,
          defaultToNothingSelected: true
        });
        //this.params.api.setColumnFilterModel('psrQty').onFilterChanged();
        this.params.api.onFilterChanged();

        if (!this.hasServerSideDatasource) {
          setTimeout(() => {
            this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }, 500);
        }
      }
    });

  }

  getPortfolioCreatedBy() {
    this.pfs.getPortfolioCreatedBy().subscribe((res: string[]) => {
      this.portfolioCreatedUserList = res;
    });

  }

  getPortfolioEditedBy() {
    this.pfs.getPortfolioEditedBy().subscribe((res: string[]) => {
      this.portfolioEditedUserList = res;
    });

  }

  setPortfolioSetFilter(fieldName: string, setValuesList: string[]) {
    const portfolioFilterComponent = this.params.api.setColumnFilterModel(fieldName);
    portfolioFilterComponent.setModel({
      type: 'set',
      values: setValuesList,
      defaultToNothingSelected: true
    });
    portfolioFilterComponent.setFilterValues(setValuesList);
  }

  getPortfolioSetFilterSelectedGetIds(params: any, fieldName: string) {
    const selectedValues = params.request.filterModel[fieldName]?.values || [];
    return selectedValues;
  }

  getSetFilterSelectedGetIds(params: any, list: any, fieldName: string) {
    const selectedValues = params.request.filterModel[fieldName]?.values || [];
    list = list?.filter((x: any) => selectedValues.includes(x.name));
    if (list && params.request && params.request.filterModel && params.request.filterModel[fieldName])
      params.request.filterModel[fieldName].list = list;
    const r = list?.map((x: any) => x.id) || [];
    return r;
  }

  statusStyle(params: any) {
    if (params.value === 'incomplete') {
      return {color: '#D30014'};
    } else {
      return null;
    }
  }

  clearAllFilters() {
    this._filterCriteria = '';
    this.pfs._filterCriteria = '';
    this.dts.SecurityModelId = 0;
    this.securityModelId = 0;
    this.pfs.clearCriteria();
    this.saveGridFiltersToLocal(null);

    this.params.api.setFilterModel(null);
    this.missingCountDetails.withoutAccount = false;
    this.missingCountDetails.withoutModel = false;
    this.quickfilterSetModel(this.missingCountDetails);
  }

  clearAllFiltersAndSelections() {
    this.params.api.deselectAll();
    this.clearAllFilters();
    this.isSelectedAll = false;
    this.selectedRowsMap = new Map<string, any>();
    this.deselectedFromSelectAllRecords = [];
    this.headerCheckBoxState = 'unchecked';
    this.enableDisableBtns();
  }

  setPortfolioCategoryFilterEvent() {
    this.applyFilterOnLanding.isUpdatRequired = false;
    this.params.api.deselectAll();
    this._filterCriteria = '';
    this.pfs._filterCriteria = '';
    this.dts.SecurityModelId = 0;
    this.securityModelId = 0;
    this.pfs.clearCriteria();
    this.missingCountDetails.withoutAccount = false;
    this.missingCountDetails.withoutModel = false;
    this.isSelectedAll = false;
    this.headerCheckBoxState = 'unchecked';
    this.enableDisableBtns();
    this.saveGridFiltersToLocal(null);

    let filterModel: any = {
      'labels': {values: [this.applyFilterOnLanding.filterModel.value]},
      'quickfilter': this.missingCountDetails
    };
    
    this.params.api.getColumnFilterInstance("labels").then((_f: any) => {
      this.params.api.setFilterModel(filterModel);
    });
    this.params.api.onFilterChanged();
  }

  showImportModelAndCategoryDialog() {
    this.ats.trackClickEvent("md_import");
    this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_MODEL_CATEGORY);
  }

  showImportPortfolioNameDialog() {
    this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_PORTFOLIO_NAMES);
  }

  completeImportModelCategory(data: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.pfs.updateImportModelAndCategory(data.validRecords).subscribe((d: IRebalResponseObject) => {
      if (d.responseStatus === "SUCCESS") {
        this.checkUpdateModelAndCategoryAsyncStatus(d.responseUtilityMap.statusId);
      } else if (d.responseStatus === "BUSINESS_ERR_MSG" || d.responseStatus === "EXCEPTION") {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Model and Category',
              detail: "An error occurred while processing your request."
          });
      } else if (d.responseStatus === "STALEDATAEXCEPTION") {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Model and Category',
              detail: "You are attempting to import items which were modified by another user. Please try your import again."
          });
      }
    }, () => {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  checkUpdateModelAndCategoryAsyncStatus(updateStatusId: string) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.updateImportModelAndCategorySub = interval(intervalValue).subscribe(() => {
      this.pfs.updateImportModelAndCategoryStatus(updateStatusId).subscribe((response: any) => {
        if (response.responseUtilityMap?.requestStatus?.toUpperCase() === "COMPLETED") {
          this.updateImportModelAndCategorySub.unsubscribe();
          this.updateModelAndCategoryComplete(response);
        } else if (response.responseStatus !== "SUCCESS" ||
          (response.responseUtilityMap?.requestStatus && response.responseUtilityMap?.requestStatus?.toUpperCase() === "FAILED")) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Model and Category',
              detail: "An error occurred processing your request."
            });
            this.updateImportModelAndCategorySub.unsubscribe();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          } else if (response.responseUtilityMap?.actionStatus?.reqStatus?.toUpperCase() === "IN_PROGRESS") {
          }
      }, () => {
        this.updateImportModelAndCategorySub.unsubscribe();
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    });
  }

  updateModelAndCategoryComplete(res: any) {
    this.hilitedPortfolios = [];
    const responseData = JSON.parse(res.responseData);
    responseData.forEach((r: any) => {
      this.hilitedPortfolios.push(r);
    });

    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'success',
      summary: 'Import Model and Category',
      detail: 'Model assignments for ' + responseData.length + ' portfolio(s) were successfully updated (highlighted below).'
    });

    this.refreshGrid();
  }

  getSelectedPortfolioIdIds() {
    return Array.from(this.selectedRowsMap.keys(), Number);
  }

  getSelectedPortfolios() {
    return Array.from(this.selectedRowsMap.values());
  }

  createRebalance() {
    this.ats.trackClickEvent("md_rebal");

    let _portfolioIdsList = this.isSelectedAll ? [] : this.getSelectedPortfolioIdIds();

    if (this.isSelectedAll) {
      const request = {} as IPortfolioExportRequest;
      request.isSelectAll = this.isSelectedAll;
      request.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        request.deselectedIds.push(node.portfolioId);
      });

      request.selectedIds = [];

      this.pfs.getIdsByFilter(request).subscribe((response: any) => {
        if (response.responseData.length > 0 && response.responseUtilityMap.authorizedCount > 0) {
          let portfolioIds: Array<number> = [];
          response.responseData.forEach((portfolioId: any) => {
            portfolioIds.push(portfolioId);
          });
          _portfolioIdsList = portfolioIds;
          this.fireCreateRebalance(_portfolioIdsList);
        } else {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Unauthorized Portfolios',
            detail: "Unauthorized portfolios cannot be rebalanced."
          });
          this.isLoading = false;
        }
      });
    } else {
      _portfolioIdsList = this.getSelectedPortfolioIdIds();

      if (_portfolioIdsList.length >= 1) {
        this.fireCreateRebalance(_portfolioIdsList);
      }
    }
  }

  fireCreateRebalance(_portfolioIdsList: Array<number>) {
    const _filterCriteria = this.isSelectedAll ? (this._filterCriteria ? ('?' + this._filterCriteria) : '') : '';
    const _selectedPortfoliosCount = _portfolioIdsList.length;
    const _serviceURL = '/irebalone/portfolios/get-ids-by-filter-criteria/' + _filterCriteria;

    if (_portfolioIdsList && _portfolioIdsList.length > 0) {
      const crConfig = {
        'serviceURL': _serviceURL,
        'portfolioIdsList': _portfolioIdsList,
        'deselectedFromSelectAllRecords': this.deselectedFromSelectAllRecords,
        'message': _selectedPortfoliosCount ? _selectedPortfoliosCount + ' portfolio(s) will be rebalanced.' : 'All portfolios will be rebalanced.'
      };
      this.as.fireEvent('createRebalance', crConfig);
    }
  }

  editSinglePortfolio(params: any, changedProperty: string) {
    const self = this;
    this.overlayType = 'loading';
    this.params.api.showLoadingOverlay();
    const d = this.util.getObjectValues(params.data, ["portfolioId", "versionId", "securityModelId", "labels", "gainsControlSetting"]);
    this.pfs.editSinglePortfolio(d).subscribe((data: IRebalResponseObject) => {
      if (data.responseStatus === 'SUCCESS') {
        this.params.api.hideOverlay();
        if (changedProperty=== 'model') {
          this.valuesCallbackList(true);
        }
        params.data.versionId = data.responseData.versionId;
        params.data.status = data.responseData.status;
        params.data.labels = data.responseData.labels;
        params.data.securityModelName = data.responseData.securityModelName;
        params.data.gainsControlSetting = data.responseData.gainsControlSetting;
        params.data.acctQty = data.responseData.acctQty;
        params.data.labels = data.responseData.labels;
        
        params.node.setData(params.data);
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'success',
          summary: 'Success',
          detail: 'Your change has been saved'
        });
      } else {
        this.params.api.hideOverlay();
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
          dTitle: 'Refresh Required',
          dProceedBtnLabel: 'Refresh',
          msg: `You're attempting to edit information that was recently changed.
            Please refresh page to see latest changes`,
          onProceed: () => {
            self.refreshGrid();
          }
        } as IAlertDialogData);
      }
    }, () => {
      this.params.api.hideOverlay();
    });
  }

  onCapitalGainsDropdownChanged(params: any, item: IDropdownItem) {
    if (params.data.gainsControlSetting !== item.value) {
      params.data.gainsControlSetting = item.value;
    }
    this.editSinglePortfolio(params,'capitalgains');
  }

  onCategoryDropdownChanged(params: any, selected: Array<IDropdownItem>) {
    if(typeof params.data.labels == "undefined") {
      params.data.labels = [];
    }

    let existing = [].concat(params.data.labels);
    let existingIds = existing.map((label: IPortfolioCustomLabel) => label.id);
    let selectedIds = selected.map((r: IDropdownItem) => r.value);
    let newItems = selected.filter((x: IDropdownItem) => !existingIds.includes(x.value) );
    let deletedItemsIds = params.data.labels.filter((x: IPortfolioCustomLabel) => !selectedIds.includes(x.id))?.map((label: IPortfolioCustomLabel) => label.id);
    
    newItems.forEach((r: IDropdownItem) => {
      params.data.labels.push({
        id: r.value,
        name: r.name,
        isNew: true
      } as IPortfolioCustomLabel);
    });

    params.data.labels.forEach((r: IPortfolioCustomLabel) => {
      if(deletedItemsIds.includes(r.id)) {
        r.isUiDeleted = true;
        delete r.isNew;
      }
    });

    if(params.data.labels.length > 0) {
      params.data.labels = this.util.sortByKey(params.data.labels, "name", "asc");
      this.editSinglePortfolio(params, 'labels');
    }    
  }

  onModelDropdownChanged(params: any, item: IDropdownItem) {
    if (params.data.securityModelName !== item.value) {
      params.data.securityModelName = item.value;
      if (params.colDef.field === 'securityModelName') {
        const selectedModelId = this.getInLineGridFilterSelectedId(item.value, this.portfolioModelList);
        params.data.securityModelId = selectedModelId;
        if (!selectedModelId) {
          params.data.securityModelName = null;
        }
      }
      this.editSinglePortfolio(params,'model');
    }
  }

  getInLineGridFilterSelectedId(selectedValue: any, list: IPortfolioFilterDDList) {
    const result = list.items.filter(s1 => s1.name === selectedValue);
    if (result[0].id === 'uncategorized' || result[0].id === 'NoModel') {
      return null;
    }
    const selectedModelId = result[0].id;
    return selectedModelId;
  }

  enableDisableBtns() {
    this.disableActionBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;

    const selectedRow = this.getSelectedPortfolios() || [];
    this.disableFinmasonBtn = selectedRow.length === 1 ? false : true;
    if (selectedRow.length === 1 && (selectedRow[0].authStatus === "Unauthorized" || !selectedRow[0].acctQty))
      this.disableFinmasonBtn = true;
  }

  createNewPortfolio() {
    this.ats.trackClickEvent("md_create");
    this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_CREATE_PORTFOLIO);
  }

  exportModelAndCategory() {
    const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

    if (headerName === 'Select All') {
      this.params.api.getAllDisplayedColumns().splice(0, 1);
    }
    if (this.isSelectedAll || this.selectedRowsMap?.size === 0) {
      const deselectedIds: any = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        deselectedIds.push(node.portfolioId);
      });

      this.pfs.exportAllPortfolioModelAndCustCat(true, deselectedIds).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});
    } else {
      const f = [...this.selectedRowsMap.keys()];
      this.pfs.exportPortfolioModelAndCustCat(this.isSelectedAll, f).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});
    }
  }

  exportPortfolioNotes() {
    const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

    if (headerName === 'Select All') {
      this.params.api.getAllDisplayedColumns().splice(0, 1);
    }
    if (this.isSelectedAll || this.selectedRowsMap?.size === 0) {
      const deselectedIds: any = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        deselectedIds.push(node.portfolioId);
      });
      this.pfs.exportAllPortfolioNotes(true, deselectedIds).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});

    } else {
      const f: any[] = [];
      this.selectedRowsMap.forEach((node: any) => {
        if (node.notesQty && node.notesQty > 0) {
          f.push(node.portfolioId);
        }
      });
      if (f.length === 0) {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'No records exported',
          detail: 'No portfolios with notes were selected.'
        });
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        return;
      }

      this.pfs.exportPortfolioNotesDetails(this.isSelectedAll, f).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});
    }
  }

  exportPortfolioRestrictions() {
    const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

    if (headerName === 'Select All') {
      this.params.api.getAllDisplayedColumns().splice(0, 1);
    }

    if (this.isSelectedAll || this.selectedOrDeSelectedRecords.length === 0) {
      const deselectedIds: any = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        deselectedIds.push(node.portfolioId);
      });

      this.pfs.exportAllPortfolioRestrictions(true, deselectedIds).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});
    } else {
      const f: any[] = [];
      this.selectedRowsMap.forEach((node: any) => {
        if (node.psrQty && node.psrQty > 0) {
          f.push(node.portfolioId);
        }
      });
      if (f.length === 0) {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'No records exported',
          detail: 'No portfolios with restrictions were selected.'
        });
        return;
      }

      this.pfs.exportPortfolioRestrictionsDetails(this.isSelectedAll, f).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      }, () => {});
    }
  }

  customFilterLayout(params: any) {
    let customToolPanelColumnDefs: any = [
      {
        headerName: 'Additional Filters',
        children: [
          {field: "accountLocationType"},
          {field: "pendingResults"},
          {field: "taxlossResults"}
        ]
      }
    ];
    if (this.ENABLE_CUSTOM_HOMEPAGE)
      customToolPanelColumnDefs[0].children.push({field: "masterAccount"});

    const filtersToolPanel = params.api.getToolPanelInstance('filters');
    filtersToolPanel.setFilterLayout(customToolPanelColumnDefs);
    const filterPanel = this.as.getItem(this.componentName + '_FilterPanel');
    if (filterPanel === true) {
      this.baseGridApi?.setSideBarVisible(true);
      this.baseGridApi?.openToolPanel('filters');
    }
  }

  customFilterLayoutWithQuickFitler(params: any) {
    let customToolPanelColumnDefs: any = [
      { field: "quickfilter" },
      {field: "accountLocationType"},
      {field: "pendingResults"},
      {field: "taxlossResults"},
    ];
    if (this.ENABLE_CUSTOM_HOMEPAGE)
      customToolPanelColumnDefs.push({field: "masterAccount"});

    const filtersToolPanel = params.api.getToolPanelInstance('filters');
    filtersToolPanel.setFilterLayout(customToolPanelColumnDefs);
    const filterPanel = this.as.getItem(this.componentName + '_FilterPanel');
    if (typeof filterPanel === 'undefined' || filterPanel === true) {
      this.baseGridApi?.setSideBarVisible(true);
      this.baseGridApi?.openToolPanel('filters');
    }
    filtersToolPanel.expandFilters(['quickfilter']);
  }

  valuesCallbackList(afterModelUpdate: boolean = false) {
    this.pfs.getQuickFilterCounts().subscribe((missingCountDetails: any) => {
      this.missingCountDetails = missingCountDetails;
      this.quickfilterSetModel(this.missingCountDetails);
      if (missingCountDetails?.missingModelCount || missingCountDetails?.missingAccountCount || missingCountDetails?.tlhExpirationCount) {
        this.customFilterLayoutWithQuickFitler(this.params);
      } else {
        if (afterModelUpdate)
          this.customFilterLayout(this.params);
      }
    });
  }

  quickfilterSetModel(missingCountDetails: IPortMissingAccountAndModel) {
    this.params.api.setColumnFilterModel('quickfilter', missingCountDetails);
  }

  getContextMenuItems(): Array<MenuItemDef> {
    return [
      {
        name: "Export CSV",
        action: this.exportDetails.bind(this)
      }
    ];
  }

  exportDetails() {
    const exportRequest = {} as IPortfolioExportRequest;
    const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

    if (headerName === 'Select All') {
      this.params.api.getAllDisplayedColumns().splice(0, 1);
    }

    if (this.isSelectedAll || this.selectedRowsMap?.size === 0) {
      exportRequest.isSelectAll = true;
      exportRequest.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        exportRequest.deselectedIds.push(node.portfolioId);
      });

      this.pfs.exportDetails(exportRequest).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      },()=>{});
    } else {
      exportRequest.isSelectAll = false;
      exportRequest.selectedIds = this.getSelectedPortfolioIdIds();
      this.pfs.exportDetails(exportRequest).subscribe((_res: any) => {
        this.ges.showSuccessMessage();
      },()=>{});
    }
  }

  deletePortfolioDialog() {
    const request = {} as IPortfolioExportRequest;

    if (this.isSelectedAll) {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      const headerName = this.params.api.getAllDisplayedColumns()[0]['colDef']['headerName'];

      if (headerName === 'Select All') {
        this.params.api.getAllDisplayedColumns().splice(0, 1);
      }
      request.isSelectAll = this.isSelectedAll;
      request.deselectedIds = [];

      this.deselectedFromSelectAllRecords.forEach((node: any) => {
        request.deselectedIds.push(node.portfolioId);
      });

      const d = this.getSelectedPortfolioIdIds();
      request.selectedIds = [];

      this.pfs.getSelectedPortfoliosData(request).subscribe((response: any) => {
        if (response.length > 0) {
          this.as.fireEvent(IrbClientsEvents.SHOW_DELETE_PORTFOLIO_DIALOG, {
            portfolios: response,
            deleteContinueFunction: this.deleteContinueCallback.bind(this)
          });
        }

        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    } else {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      const selectedPortfolios = Array.from(this.selectedRowsMap.values());
      this.as.fireEvent(IrbClientsEvents.SHOW_DELETE_PORTFOLIO_DIALOG, {
        portfolios: selectedPortfolios,
        deleteContinueFunction: this.deleteContinueCallback.bind(this)
      });
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    }
  }
  deleteContinueCallback(data: any) {
    this.selectedRowsMap = new Map<string, any>();
    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      key: 'irb-embedded-link-toast',
      severity: 'warn',
      summary: data.responseData + ' portfolio(s) were deleted.',
      detail: 'Their former accounts are now listed in ',
      life: 5000,
      linkText: 'Unassigned Accounts.',
      callBack: (() => {
        this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
        this.router.navigate(['/clients/unassigned-accounts']);
      })
    });
  }

  showSchdRebalance(data: any) {
    const paramData = {
      redirectFilterFlag: "true",
      rdirectedPortfolioName: data.portfolioName,
      rdirectedPortfolioId: data.portfolioId
    };
    this.as.setToSession('portSchReb', paramData);
    this.router.navigate(['/rebalancing/scheduled-rebalances']);
  }

  showLastResults(data: any) {
    if (this.routeQueryParams$) {
      this.routeQueryParams$.unsubscribe();
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {lastResults: data.rebalId, portfolio: data.portfolioId},
      replaceUrl: true
    });

    setTimeout(() => {
      this.as.fireEvent(IrbRebalanceEvents.SHOW_PORTFOLIO_RESULT_DETAIL, {
        fullscreen: true,
        request: {
          method: "getDetails",
          rebalId: data.rebalId,
          portfolioId: data.portfolioId,
          secListLoadReqd: true
        }
      });
    });
  }

  editMultiplePortfoliosDialog() {
    this.ats.trackClickEvent("md_port_edit");
    const r = {} as IMultiplePortfolioEditRequest;
    r.selectedIds = [];
    r.deselectedIds = [];
    r.filter = this.pfs._filterKeys;

    if (this.isSelectedAll || this.selectedRowsMap.size === 0) {
        r.isSelectAll = true;
        this.deselectedFromSelectAllRecords.forEach((node: any) => {
            r.deselectedIds.push(node.portfolioId);
        });
        r.portfolioCount = this.currentPortfoliosDisplayed - r.deselectedIds.length;
    } else {
        r.isSelectAll = false;
        r.selectedIds = this.getSelectedPortfolioIdIds();
        r.portfolioCount = r.selectedIds.length;
    }

    if(r.isSelectAll || r.selectedIds.length > 1) {
        this.checkMultiplePortfolioEligibilityStatus(r);
    } else {
        this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {
            data: {portfolioId: r.selectedIds[0]}
        });
    }
  }

  checkMultiplePortfolioEligibilityStatus(r: IMultiplePortfolioEditRequest) {
    this.ies.getAutoSchdBlockedPortfolio(r).subscribe((response: any) => {
        if (response.responseStatus && (response.responseStatus === 'FAILED' || response.responseStatus === 'EXCEPTION')) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Server Error',
              detail: "An internal server error occurred",
              sticky:true
          });
        } else if (response.responseData && response.responseData.length > 0) {
            r.actBlockAutoSchd = true;
            this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_MULTIPLE_PORTFOLIO_AUTOMATION_DIALOG, {
                portfolios: response.responseData,
                editMultiplePFContinueFunction: (() => {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_MULTIPLE_PORTFOLIOS, {data: r});
                }).bind(this)
            });
        } else {
            r.actBlockAutoSchd = false;
            this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_MULTIPLE_PORTFOLIOS, {data: r});
        }
    }, () => {

    });
  }
  finmasonCall() {
    this.ats.trackClickEvent("md_finmason_port");
    let data: any = {};
    data.loadPortfolio = true;
    data.selectedPortfolios = this.getSelectedPortfolios();
    this.as.fireEvent(IrbDialogsEvents.SHOW_FINMASON_TRAIN_SSO, data);
  }

  getPendingResults() {
    let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'pendingResults');
    if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
      // console.log(filterModel);
      this.applyFilterOnLanding.isUpdatRequired = false;
      filterModel.isUpdatRequired = false;
      this.params.api.setColumnFilterModel('pendingResults', {
        values: filterModel.value
      });
      //this.params.api.setColumnFilterModel('pendingResults').onFilterChanged();
      this.params.api.onFilterChanged();
      this.saveGridFiltersToLocal(null);

      // setTimeout(() => {
      //   this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
      // }, 500);
    }
  }

  getTaxlossResults() {
    let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'taxlossResults');
    if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
      // console.log(filterModel);
      this.applyFilterOnLanding.isUpdatRequired = false;
      filterModel.isUpdatRequired = false;
      this.params.api.setColumnFilterModel('taxlossResults', {
        values: filterModel.value,

      });
      //this.params.api.setColumnFilterModel('taxlossResults').onFilterChanged();
      this.params.api.onFilterChanged();
      this.saveGridFiltersToLocal(null);
      // setTimeout(() => {
      //   this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
      // }, 500);
    }
  }
  getAssignedMMC() {
    let filterModel: IFilterModel = this.as.getFieldInfo(this.applyFilterOnLanding, 'isAssignedMMC');
    if (filterModel && filterModel.value && filterModel.isUpdatRequired) {
      this.applyFilterOnLanding.isUpdatRequired = false;
      filterModel.isUpdatRequired = false;
      this.params.api.setColumnFilterModel('isAssignedMMC', {
        values: filterModel.value,

      });
      this.params.api.onFilterChanged();
      this.saveGridFiltersToLocal(null);
    }
  }
  private getCurrentPortfolioCount(headers: HttpHeaders) {
    this.portfolioContentRange = headers.get('Filter-Count');
    const lengthOfContentRange = this.portfolioContentRange ? this.portfolioContentRange.trim().length : 0;
    const indexOfSlash = this.portfolioContentRange ? this.portfolioContentRange.toString().indexOf('/') : 0;
    this.currentPortfoliosDisplayed = this.portfolioContentRange ? parseInt(this.portfolioContentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
    this.footerContent = this.currentPortfoliosDisplayed + ' of ' + this.portfolioCount?.pfCount + ' portfolios displayed';
    this.totalRecordsFromServer = this.currentPortfoliosDisplayed;

    if (this.firstTimeFlag)
      this.addHiddenColumnFiltersOnInitialLoad();
  }

  resetCategorySearch(dataParam: any) {
    let newAddData: any;

    if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
      for (let i = 0; i < dataParam.newItems.length; i++) {
        newAddData = {
          id: dataParam.newItems[i].custCatId.toString(),
          name: dataParam.newItems[i].custCatName
        };

        this.pls.portfolioLabels.push(newAddData);
      }

      this.params.api.forEachNode((node: any) => {
        if (node.rowIndex === dataParam.rowIndex) {
          this.onCategoryDropdownChanged(node, [{
            name: dataParam.newItemsForDD[0].name,
            value: dataParam.newItemsForDD[0].name
          }]);
        }
      });
    }
  }

  private setFilterChipsDisplayNames() {
    this.filterDisplayNamesData= [];
    this.filterDisplayNamesData.push({key: 'portfolioName', mapData: {displayName: 'Name', customData:{}}});
    this.filterDisplayNamesData.push({key: 'status', mapData: {displayName: 'Status', customData:{}}});
    this.filterDisplayNamesData.push({key: 'totalPortfolioValue', mapData: {displayName: 'Value', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'labels', mapData: {displayName: this.customCategory, customData:{}}});
    this.filterDisplayNamesData.push({key: 'psrQty', mapData: {displayName: 'Restrictions', customData:{}}});
    this.filterDisplayNamesData.push({key: 'securityModelName', mapData: {displayName: 'Model', customData:{}}});
    this.filterDisplayNamesData.push({key: 'gainsControlSetting', mapData: {displayName: 'Gains Restriction', customData:{}}});
    this.filterDisplayNamesData.push({key: 'acctQty', mapData: {displayName: 'Accounts', customData:{}}});
    this.filterDisplayNamesData.push({key: 'isAutoRebalEnabled', mapData: {displayName: 'Automated', customData:{}}});
    this.filterDisplayNamesData.push({key: 'shortTermGainLoss', mapData: {displayName: 'ST G/L', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'longTermGainLoss', mapData: {displayName: 'LT G/L', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'totalGainLoss', mapData: {displayName: 'YTD G/L', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'gainsThresholdAmt', mapData: {displayName: 'Gains Threshold', customData:{}, format: {type:'currency', digitInfo:'1.0-0'}}});
    this.filterDisplayNamesData.push({key: 'notesQty', mapData: {displayName: 'Notes', customData:{}}});
    this.filterDisplayNamesData.push({key: 'lastResult', mapData: {displayName: 'Last Result', customData:{}}});
    this.filterDisplayNamesData.push({key: 'nextRebalDate', mapData: {displayName: 'Next Date', customData:{}}});
    this.filterDisplayNamesData.push({key: 'createdDate', mapData: {displayName: 'Created On', customData:{}}});
    this.filterDisplayNamesData.push({key: 'createdBy', mapData: {displayName: 'Created By', customData:{}}});
    this.filterDisplayNamesData.push({key: 'modifiedDate', mapData: {displayName: 'Edited On', customData:{}}});
    this.filterDisplayNamesData.push({key: 'modifiedBy', mapData: {displayName: 'Edited By', customData:{}}});
    this.filterDisplayNamesData.push({key: 'accountLocationType', mapData: {displayName: 'Taxability', customData:{valueMaps: {'DEFERRED': 'Deferred', 'ROTH':'Roth','TAXABLE':'Taxable'}}}});
    this.filterDisplayNamesData.push({key: 'withHighNotes', mapData: {displayName: 'With high-priority notes', customData:{valueMaps: {'YES': 'Yes', 'NO':'No'}}}});
    this.filterDisplayNamesData.push({key: 'pendingResults', mapData: {displayName: 'Pending Results', customData:{}}});
    this.filterDisplayNamesData.push({key: 'withoutModel', mapData: {displayName: 'Missing models', customData:{}}});
    this.filterDisplayNamesData.push({key: 'withoutAccount', mapData: {displayName: 'Missing accounts', customData:{}}});
    this.filterDisplayNamesData.push({key: 'taxlossResults', mapData: {displayName: 'TLH expiration', customData:{}}});
    this.filterDisplayNamesData.push({key: 'isAssignedMMC', mapData: {displayName: 'Assigned to MMC', customData:{}}});
    this.filterDisplayNamesData.push({key: 'masterAccount', mapData: {displayName: 'Master Account(s)', customData:{}}});
  }
  onRemoveFilterItem(filterChip: any) {
    let filterField = filterChip[0];
    if (filterField === 'withoutModel' ||
      filterField === 'withoutAccount' ||
      filterField === 'taxlossResults') {
      this.clearAllFilters();
      this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
    } else {
      this.missingCountDetails.withoutAccount = false;
      this.missingCountDetails.withoutModel = false;
      this.missingCountDetails.taxlossResults = false;
      this.quickfilterSetModel(this.missingCountDetails);
      this.params.api.setColumnFilterModel(filterField, null);
      this.params.api.onFilterChanged();
    }
  }

  setQuickFiltersInChipModel() {
    this.saveGridFiltersToLocal(this._filterChipModel);
    if (this._filterChipModel) {
      let _filterChips: any[] = [];
      // IREBAL-70434
      const quickFilterKeys = ['quickfilter', 'withoutModel', 'withoutAccount', 'taxlossResults'];
      Object.entries(this._filterChipModel).map((item: any) => {
        if (!quickFilterKeys.includes(item[0])) {
          _filterChips.push(item);
        }
      });

      if (_filterChips.length > 0 && this.missingCountDetails) {
        this.missingCountDetails.withoutAccount = false;
        this.missingCountDetails.withoutModel = false;
        this.missingCountDetails.taxlossResults = false;
        this._filterChipModel.quickfilter = this.missingCountDetails;
      }
      if (this._filterChipModel.quickfilter) {
        if (this._filterChipModel.quickfilter.withoutModel) {
          this._filterChipModel.withoutModel = {
            filterType: 'quickFilter',
            value: this._filterChipModel.quickfilter?.missingModelCount
          };
        }
        if (this._filterChipModel.quickfilter.withoutAccount) {
          this._filterChipModel.withoutAccount = {
            filterType: 'quickFilter',
            value: this._filterChipModel.quickfilter?.missingAccountCount
          };
        }
        if (this._filterChipModel.quickfilter.taxlossResults) {
          this._filterChipModel.taxlossResults = {
            filterType: 'quickFilter',
            value: this._filterChipModel.quickfilter?.tlhExpirationCount
          };
        }
      }
    }
  }

  addRemoveFilterToPanel() {
    let customToolPanelColumnDefs: any;
    customToolPanelColumnDefs = [
      {
        headerName: 'Additional Filters',
        children: [
          {field: "accountLocationType"},
          {field: "pendingResults"},
          {field: "taxlossResults"},
        ]
      }
    ];
    if (this.ENABLE_CUSTOM_HOMEPAGE)
      customToolPanelColumnDefs[0].children.push({field: "masterAccount"});

    if (this.missingCountDetails?.missingModelCount || this.missingCountDetails?.missingAccountCount || this.missingCountDetails?.tlhExpirationCount) {
      customToolPanelColumnDefs[0].children.unshift({field: "quickfilter"});
      customToolPanelColumnDefs = customToolPanelColumnDefs[0].children;
    }

    return customToolPanelColumnDefs;
  }
  
  listOfExpandFilters() {
    return ['quickfilter'];
  }

  addHiddenColumnFiltersOnInitialLoad() {
    setTimeout(() => {
      this.firstTimeFlag = false;
      if (this.params && this.params.api) {
        const col = this.params.api.getColumn('modifiedBy');
        if (col) {
          let colVisibility: any = col.visible;
          this.params.api.setColumnsVisible(['modifiedBy'], !colVisibility);
          this.params.api.setColumnsVisible(['modifiedBy'], colVisibility);
        }
      }
    }, 1000);
  }

  completeImportPortfolioNames(data: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.cs.updateImportPortfolioName(data.validRecords).subscribe((d: any) => {
        if (d.responseStatus === "SUCCESS") {
            this.checkUpdatePortfolioNameAsyncStatus(d.responseUtilityMap.statusId);
        } else if (d.responseStatus === "BUSINESS_ERR_MSG" || d.responseStatus === "EXCEPTION") {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Import Portfolio Names',
                detail: "An error occurred while processing your request."
            });
        } else if (d.responseStatus === "STALEDATAEXCEPTION") {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Import Portfolio Names',
                detail: "You are attempting to import items which were modified by another user. Please try your import again."
            });
        }
    }, () => {
         this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  checkUpdatePortfolioNameAsyncStatus(updateStatusId: string) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.updatePortfolioNamesSub = interval(intervalValue).subscribe(() => {
      this.cs.updateImportPortfolioNamesStatus(updateStatusId).subscribe((response: any) => {
        if (response.responseUtilityMap?.requestStatus?.toUpperCase() === "COMPLETED") {
          this.updatePortfolioNamesSub.unsubscribe();
          this.updatePortfolioNamesComplete(response);
        } else if(response.responseStatus !== "SUCCESS" ||
          (response.responseUtilityMap?.requestStatus && response.responseUtilityMap?.requestStatus?.toUpperCase() === "FAILED")) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Import Portfolio Names',
              detail: "An error occurred processing your request."
            });
            this.updatePortfolioNamesSub.unsubscribe();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          } else if(response.responseUtilityMap?.actionStatus?.reqStatus?.toUpperCase() === "IN_PROGRESS") {
          }
      }, () => {
        this.updatePortfolioNamesSub.unsubscribe();
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    });
  }

  updatePortfolioNamesComplete(res: any) {
    this.hilitedPortfolios = [];
    const responseData = JSON.parse(res.responseData);
    responseData.forEach((r: any) => {
      this.hilitedPortfolios.push(r);
    });

    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'success',
      summary: 'Import Portfolio Names',
      detail: "The names for " + responseData.length + " portfolio(s) were successfully updated (highlighted below)."
    });

    this.refreshGrid();
  }

  openGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {
      defaultTabIndex: 2, 
      onFirstLoad: () => { 
        setTimeout(() => { 
          this.as.fireEvent(IrbSettingsEvents.EXPAND_CUSTOM_LABELS);
          document.getElementById("CUSTOM_CATEGORIES")?.scrollIntoView(); 
        });
      }
    });
  }

  presetFiltersdataFromSavedFilters() {
    let savedFilters = this.getGridFilterPreference();
    if (!savedFilters)
      return;

    if (savedFilters.acctQty)
      this.filterAccounts = savedFilters.acctQty.values;

    if (savedFilters.psrQty)
      this.restrictionNames = savedFilters.psrQty.values;

    if (savedFilters.masterAccount)
      this.masterAccountList = savedFilters.masterAccount.values;

    if (savedFilters.securityModelName) {
      this.modelNames = savedFilters.securityModelName.values;
      this.portfolioModelList = {items: savedFilters.securityModelName.list, identifier:'', label:''};
    }

    if (savedFilters.labels) {
      let filterData = [];
      for (let i=0; i<savedFilters.labels.values.length; i++) {
        if (savedFilters.labels.values[i] !== 'uncategorized')
          filterData.push({id: savedFilters.labels.values[i], name: savedFilters.labels.displayValues[i]})
      }
      if (filterData.length)
        this.pls.portfolioLabels = filterData;
    }

    if (savedFilters.createdBy)
      this.portfolioCreatedUserList = savedFilters.createdBy.values;

    if (savedFilters.modifiedBy)
      this.portfolioEditedUserList = savedFilters.modifiedBy.values;

  }

  getMasterNumberList() {
    this.pfs.getMasterAccountList().subscribe((res: any) => {
      this.masterAccountList = res;
      const setFilter = this.params.api.getColumnFilterHandler('masterAccount');
      if (setFilter) {
        setFilter.refreshFilterValues();

        if(this.applyFilterOnLanding && this.applyFilterOnLanding.filterModels) {
          this.applyFilterOnLanding.filterModels?.forEach((filterModel: IFilterModel) => {
            if (filterModel.isUpdatRequired && filterModel.name) {
              filterModel.isUpdatRequired = false;

              this.params.api.setColumnFilterModel(filterModel.name, {
                values: filterModel.value
              });
            }
          });
          setTimeout(() => {
            this.saveGridFiltersToLocal(null);
            this.params.api.onFilterChanged();
            this.params.api.setGridOption('serverSideDatasource', this.setDatasource());
          }, 1);
        }
      };
    });
  }
}
